import ErrorView from './ErrorView'
export default ErrorView